var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBtn',{attrs:{"to":_vm.to,"color":"primary","exact":"","depressed":""}},[_c('VIcon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.mdiRefresh))]),_vm._v(" Spróbuj ponownie ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }